import NavDashboard from "../Navigation/NavDashboard";
import PropTypes from "prop-types";

const PageContentContainer = ({ 
  children,
  // Finance-specific props
  selectedMonth,
  selectedCurrency,
  onMonthChange,
  onCurrencyChange,
  allCurrencies,
  authUserData
}) => {
  return (
    <div className="w-full min-h-screen flex flex-col  background-page-color">
      <NavDashboard 
        selectedMonth={selectedMonth}
        selectedCurrency={selectedCurrency}
        onMonthChange={onMonthChange}
        onCurrencyChange={onCurrencyChange}
        allCurrencies={allCurrencies}
        authUserData={authUserData}
      />
      <div className="flex-1 pb-30 pt-4 sm:pb-4 md:pb-6 px-2 sm:px-4 md:px-6 flex flex-col gap-5">
        {children}
      </div>
    </div>
  );
};

PageContentContainer.propTypes = {
  children: PropTypes.node.isRequired,
  // Finance-specific props
  selectedMonth: PropTypes.string,
  selectedCurrency: PropTypes.string,
  onMonthChange: PropTypes.func,
  onCurrencyChange: PropTypes.func,
  allCurrencies: PropTypes.array,
  authUserData: PropTypes.object,
};

export default PageContentContainer;
